import React, { useMemo } from "react";
import styled from "styled-components";
import PathwayTextInputGroup from "../_UI/Components/Inputs/PathwayTextInputGroup";
import { getCountryList } from "../_services/phone-utils";

const PhoneNumberInput = ({
    phoneCountryCode,
    phoneLocal,
    onCountryCodeChange,
    onPhoneLocalChange,
    disabled = false,
    required = false,
    error = "",
    label = "Telefonnummer",
    placeholder = "xxx xxx xxxx",
    countryCodeDataCy = "phone-country-code-select",
    phoneInputDataCy = "phone-number-input",
}) => {
    const countryList = useMemo(() => getCountryList(), []);

    const handleCountryCodeChange = (ev) => {
        onCountryCodeChange(ev.target.value);
    };

    const handlePhoneLocalChange = (ev) => {
        // Only allow digits
        const value = ev.target.value.replace(/\D/g, "");
        onPhoneLocalChange(value);
    };

    return (
        <PhoneFieldWrapper>
            <Label>
                {label}
                {required && <RequiredMark> *</RequiredMark>}
            </Label>
            <PhoneRow>
                <CountrySelect
                    value={phoneCountryCode}
                    onChange={handleCountryCodeChange}
                    data-cy={countryCodeDataCy}
                    disabled={disabled}
                >
                    {countryList.map((c) => (
                        <option key={`${c.iso}-${c.code}`} value={c.code}>
                            {c.name} {c.code}
                        </option>
                    ))}
                </CountrySelect>
                <PathwayTextInputGroup
                    name="phoneNumberLocal"
                    value={phoneLocal}
                    submitted={false}
                    handleChange={handlePhoneLocalChange}
                    dataCy={phoneInputDataCy}
                    placeHolder={placeholder}
                    disabled={disabled}
                />
            </PhoneRow>
            {error && <PhoneError data-cy="phone-number-error">{error}</PhoneError>}
        </PhoneFieldWrapper>
    );
};

export default PhoneNumberInput;

const PhoneFieldWrapper = styled.div`
    display: grid;
    row-gap: var(--gap-s);
`;

const Label = styled.label`
    font-weight: 600;
    color: var(--text-primary);
`;

const PhoneRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: var(--gap-s);
    align-items: center;
`;

const CountrySelect = styled.select.attrs({ className: "form-control" })`
    width: 100%;
    box-sizing: border-box;
`;

const RequiredMark = styled.span`
    color: var(--danger, #dc3545);
`;

const PhoneError = styled.div`
    color: var(--danger, #dc3545);
    font-size: 0.875rem;
`;
